import {
  NEW_CARD_SCORE_INCREASE,
  NEW_CARD_SCORE_INCREASE_OVER_TIME,
  CREDIT_REPAIR_EXPERT,
  SELF,
  getActionName,
} from 'partial/OfferManager/module.constants';

export const getSimulationTrackingAttributes = (actionName, simulationObj) => {
  let attrs = {};
  if (actionName && simulationObj) {
    switch (actionName) {
      case SELF:
        attrs = prepSimulationAttributes(simulationObj.selfSim, actionName);
        break;
      case NEW_CARD_SCORE_INCREASE:
        attrs = prepSimulationAttributes(
          simulationObj.newCardScoreIncreaseSim,
          actionName,
          simulationObj.creditApplicationDeniedSim,
        );
        break;
      case NEW_CARD_SCORE_INCREASE_OVER_TIME:
        attrs = prepSimulationAttributes(
          simulationObj.newCardScoreSim,
          actionName,
        );
        break;
      case CREDIT_REPAIR_EXPERT:
        attrs = prepSimulationAttributes(
          simulationObj.creditRepairExpertSim,
          actionName,
        );
        break;
      default:
        attrs = {};
        break;
    }
  }

  return { module: actionName, ...attrs };
};

export const prepSimulationAttributes = (
  simulation,
  type,
  creditApplicationDeniedSim,
) => {
  let simulationAttr = {};

  if (simulation) {
    simulationAttr = {
      'Simulation Name': getActionName(type),
      'Simulation Source': 'CS',
    };

    if (type === NEW_CARD_SCORE_INCREASE) {
      simulationAttr['Simulation Score Approved'] =
        simulation.creditScoreChange;
      simulationAttr['Simulation Score Declined'] = creditApplicationDeniedSim
        ? creditApplicationDeniedSim.creditScoreChange
        : null;
    } else if (simulation.scoreOverTimeData) {
      simulationAttr['Simulation Score 1 month'] =
        simulation.scoreOverTimeData['1'][0].score - simulation.creditScore;
      simulationAttr['Simulation Score 6 months'] =
        simulation.scoreOverTimeData['6'][0].score - simulation.creditScore;
    }
  }

  return simulationAttr;
};

export const OcfSimulationTrackingAttributes = (
  isIncreaseOverTime,
  simulation1,
  simulation2,
) => {
  if (isIncreaseOverTime) {
    return {
      'Simulation Name': 'New Card Score Over Time',
      'Simulation Score 1 month': simulation1,
      'Simulation Score 6 month': simulation2,
      'Simulation Source': 'CS',
    };
  }
  return {
    'Simulation Name': 'New Card Score Increase',
    'Simulation Score Approved': simulation1,
    'Simulation Score Declined': simulation2,
    'Simulation Source': 'CS',
  };
};
